<div class="dialog-viewer">
  <div class="container-fluid">
    <div class="row">
      <h2 mat-dialog-title>Edit Outing</h2>
  </div>
  </div>
  <mat-dialog-content>
    <div class="container-fluid">
      <div class="row">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field>
            <mat-label>Outing Name</mat-label>
            <input matInput placeholder="Name" [(ngModel)]="outing.name">
          </mat-form-field>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="container-fluid">
      <button mat-raised-button (click)="submit()" [disabled]="isLoading">Save</button>
      <button mat-raised-button (click)="diaglogRef.close()" color="warn" [disabled]="isLoading">Cancel</button>
    </div>
  </mat-dialog-actions>
</div>